import { createRoute, Link } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { T, useGT } from 'gt-react';
import Page from '@/components/page/Page';
import { ProjectWorkspaceView } from './ProjectWorkspaceView';
import { useProjectWorkspaceController } from './useProjectWorkspaceController';
import {
  Route as pathlessAuthenticatedRoute,
  requireFeatureFlag,
  requirePermission,
} from '../route';

function ProjectWorkspacePage() {
  const { projectId } = Route.useParams();
  const gt = useGT();
  const { project, viewProps } = useProjectWorkspaceController(projectId);
  return (
    <>
      <nav
        aria-label={gt('Breadcrumb', {
          context: 'project breadcrumb navigation',
        })}
        className="flex items-center gap-2 px-6 pt-4 text-sm text-muted-foreground"
      >
        <Link to="/projects" className="hover:text-foreground hover:underline">
          <T context="projects breadcrumb">Projects</T>
        </Link>
        <span aria-hidden="true">/</span>
        <span aria-current="page" className="truncate text-foreground">
          {project.data?.name ??
            gt('Project', { context: 'project workspace page title fallback' })}
        </span>
      </nav>
      <Page
        title={
          project.data?.name ??
          gt('Project', { context: 'project workspace page title fallback' })
        }
        subtitle={project.data?.description ?? undefined}
        isLoading={project.isPending}
        error={project.error ?? undefined}
      >
        <ProjectWorkspaceView {...viewProps} />
      </Page>
    </>
  );
}

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/projects/$projectId',
  component: ProjectWorkspacePage,
  beforeLoad: async ({ context }) => {
    requireFeatureFlag('projects-enabled');
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Project,
    });
  },
});
